import type { FormSchemaVersion } from '../../services/api/types.gen';
import type { RogerDocFormType } from '../../services/api/models/RogerDocFormType';
import type { VisitTypeId } from '../../services/api/models/VisitTypeId';

/** US — unlikely in RogerDoc identifiers; avoids collision in composite ids */
export const SCHEMA_STUDIO_PICK_SEP = '\u001f';

export type FormSchemaStudioPick = {
  id: string;
  rogerDocFormType: RogerDocFormType;
  /** Canonical VisitTypeId for RogerDoc EMR APIs when multiple aliases share a form family */
  visitType: VisitTypeId;
  /** `display_label` from GET /rogerdoc/form-type-catalog */
  formTypeDisplayLabel: string;
  /** Row label for schema dropdowns */
  label: string;
  schemaVersion: FormSchemaVersion;
};

/** One option per RogerDoc logical version: pairs `schema_version.{name,version}`. */
export function makeFormSchemaVersionPickId(
  schemaVersion: FormSchemaVersion
): string {
  return [schemaVersion.name, schemaVersion.version ?? ''].join(
    SCHEMA_STUDIO_PICK_SEP
  );
}
